/* eslint-disable no-console */
<template>
  <div class="add-switch-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="700px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="params" :rules="rules" label-width="100px">
        <div class="from-items">
          <div class="items">
            <el-form-item label="标题:" prop="title">
              <el-input v-model="params.title" size="small" placeholder="请输入消息标题"></el-input>
            </el-form-item>
          </div>
          <div class="items">
            <el-form-item label="发送者:" prop="sender">
              <el-select v-model="params.sender" size="small" placeholder="请选择发送者">
                <el-option v-for="item in sender" :value="item.value" :label="item.label" :key="item.value"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="from-items">
          <div class="items">
            <el-form-item label="接受者:" prop="receiver">
              <el-select v-model="params.receiver" size="small" placeholder="请选择接受者">
                <el-option v-for="item in receiver" :value="item.value" :label="item.label" :key="item.value"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="items">
            <el-form-item label="通知类型:" prop="noticeType">
              <el-select v-model="params.noticeType" size="small" placeholder="请选择通知类型">
                <el-option v-for="item in messageType" :value="item.value" :label="item.label" :key="item.value"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="from-items">
          <div class="items" v-if="params.noticeType === 'REGULAR_NOTICE_TYPE' || params.noticeType === 'PLAN_NOTICE_TYPE'">
            <el-form-item label="开始时间:" prop="startAt">
              <el-date-picker v-model="params.startAt" type="datetime" :picker-options="pickerOptions" placeholder="请输入开始时间" size="small"> </el-date-picker>
            </el-form-item>
          </div>
          <div class="items" v-if="params.noticeType === 'PLAN_NOTICE_TYPE'">
            <el-form-item label="结束时间:" prop="endAt">
              <el-date-picker v-model="params.endAt" type="datetime" :picker-options="pickerOptions" placeholder="请输入结束时间" size="small"> </el-date-picker>
            </el-form-item>
          </div>
        </div>
        <div class="from-items">
          <div class="items" v-if="params.noticeType === 'REGULAR_NOTICE_TYPE' || params.noticeType === 'AFTER_REGIST_NOTICE'">
            <el-form-item label="单位选择:" prop="timeUnit">
              <el-select v-model="params.timeUnit" size="small" placeholder="请选择单位">
                <el-option v-for="item in timeUnit" :value="item.value" :label="item.label" :key="item.value"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="items">
            <el-form-item label="执行次数:" prop="planCount" v-if="params.noticeType === 'PLAN_NOTICE_TYPE'">
              <el-input v-model.number="params.planCount" size="small" placeholder="请输入执行次数"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="from-items">
          <div class="items">
            <el-form-item label="开关:" prop="turnOn">
              <el-switch v-model="params.enable">
              </el-switch>
            </el-form-item>
          </div>
          <div class="items" v-if="params.noticeType === 'REGULAR_NOTICE_TYPE' || params.noticeType === 'AFTER_REGIST_NOTICE'">
            <el-form-item label="量:" prop="timeCount">
              <el-input v-model.number="params.timeCount" size="small" placeholder="请输入量"></el-input>
            </el-form-item>
          </div>
        </div>
        <el-form-item label="用户列表:" prop="uidList" v-if="params.receiver === 'SOME_USER'">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6}" placeholder="请输入用户列表，用“,”号隔开 如：123,456,789" v-model="userListStr" @input="changeUserList">
          </el-input>
        </el-form-item>
        <div class="from-items" v-if="params.noticeType === 'SPECIFY_NOTICE_TYPE'">
          <div class="items times">
            <el-form-item label="执行时间:" prop="specifyTimeList">
              <el-input type="textarea" :disabled="false" :autosize="{ minRows: 2, maxRows: 6}" placeholder="请输入选择执行时间" v-model="specifyTimeList" @input="changeSpect">
              </el-input>
            </el-form-item>
          </div>
          <div class="items">
            <el-date-picker v-model="timeData" type="datetime" placeholder="请选择执行时间" :picker-options="pickerOptions" size="small" @change="getTime"> </el-date-picker>
          </div>
        </div>
        <el-form-item label="备注:" prop="remark">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6}" placeholder="请输入备注" v-model="params.remark">
          </el-input>
        </el-form-item>
        <el-form-item label="内容:" prop="content">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6}" placeholder="请输入内容" v-model="params.content">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
import { changeTime, deleteDateZone } from '@/utils/global.js'
export default {
  data() {
    return {
      dialogVisible: false,
      id: '',
      // 执行时间数据
      timeData: "",
      // 执行时间数组
      timeArray: [],
      // 规定当前选择时间不能小于当前时间 
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      // 通知类型
      messageType: [
        {
          label: "定时通知",
          value: 'REGULAR_NOTICE_TYPE',
        },
        {
          label: "计划通知",
          value: 'PLAN_NOTICE_TYPE',
        },
        {
          label: "规定通知",
          value: 'SPECIFY_NOTICE_TYPE',
        },
        {
          label: "注册后通知",
          value: 'AFTER_REGIST_NOTICE',
        }
      ],
      // 发送者
      sender: [
        {
          label: "System 系统消息",
          value: 'SYSTEM',
        },
        {
          label: "ActAsst 活动助手",
          value: 'ACTASST',
        },
      ],
      // 接受者
      receiver: [
        {
          label: "所有用户",
          value: 'ALL_USER',
        },
        {
          label: "部分用户",
          value: 'SOME_USER',
        },
      ],
      // 单位
      timeUnit: [
        {
          label: "天",
          value: "DAY"
        },
        {
          label: "时",
          value: "HOUR"
        },
        {
          label: "分",
          value: "MINUTE"
        }
      ],
      title: '',
      flag: false,
      operType: 'add',
      specifyTimeList: '',
      userListStr: '',
      // 请求参数
      params: {
        noticeType: '',
        title: '',
        sender: '',
        receiver: '',
        enable: false,
        uidList: [],
        content: '',
        remark: '',
        startAt: '',
        endAt: '',
        timeUnit: '',
        timeCount: '',
        planCount: '',
        specifyTimeList: [],
      },
      rules: {
        noticeType: [{ required: true, message: '请选择通知类型', trigger: 'change' }],
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        sender: [{ required: true, message: '请选择发送者', trigger: 'change' }],
        receiver: [{ required: true, message: '请选择接受者', trigger: 'change' }],
      }
    }
  },
  methods: {
    open(type, data) {
      this.dialogVisible = true;
      this.operType = type;
      if (type === 'add') {
        this.title = "添加消息通知"
      } else {
        this.title = "编辑消息通知"
        this.id = data._id;
        this.userListStr = data.uidList && data.uidList.length > 0 ? data.uidList.join(",") : ''
        this.timeData = ""
        // 转换时间
        let newDate = []
        this.timeArray = data.specifyTimeList
        if (data.specifyTimeList && data.specifyTimeList.length > 0) {
          data.specifyTimeList.map(item => {
            newDate.push(item)
          })
          this.specifyTimeList = newDate.join(",")
        } else {
          this.specifyTimeList = ""
        }
        this.params = {
          noticeType: data.noticeType,
          title: data.title,
          sender: data.sender,
          receiver: data.receiver,
          enable: data.enable,
          uidList: [],
          content: data.content,
          remark: data.remark,
          startAt: data.startAt ? deleteDateZone(data.startAt) : '',
          endAt: data.endAt ? deleteDateZone(data.endAt) : '',
          timeUnit: data.timeUnit,
          timeCount: data.timeCount,
          planCount: data.planCount,
          specifyTimeList: data.specifyTimeList,
        }
      }
    },
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true
          if (this.params.startAt) {
            this.params.startAt = changeTime(this.params.startAt)
          }
          if (this.params.endAt) {
            this.params.endAt = changeTime(this.params.endAt)
          }
          if (this.operType === 'add') {
            this.addMessage()
          } else {
            this.editMessage()
          }
        } else {
          return false;
        }
      });
    },
    addMessage() {
      API.addMessage(this.params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '新增成功',
            type: 'success'
          });
          this.$emit('handlerMessage')
        } else {
          this.$message.error('新增失败,请重试');
        }
        this.handleClose();
        this.flag = false
      })
    },
    editMessage() {
      let params = Object.assign(this.params, { id: this.id });

      API.editMessage(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '编辑成功',
            type: 'success'
          });
          this.$emit('handlerMessage')
        } else {
          this.$message.error('编辑失败,请重试');
        }
        this.handleClose();
        this.flag = false
      })
    },
    // 监听用户输入，转换用户id数组
    changeUserList(str) {
      this.params.uidList = str.split(',').map(Number)
    },
    // 监听用户选择时间， 并转换成字符串
    changeSpect(str) {
      this.params.specifyTimeList = str.split(',')
    },
    // 获取执行时间
    getTime(time) {
      if (time) {
        if (this.operType === 'add') {
          this.timeArray.push(changeTime(time))
        } else {
          this.timeArray = this.timeArray.concat(changeTime(time))
        }
        this.params.specifyTimeList = this.timeArray
        this.specifyTimeList = this.timeArray.join(',')
      }
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.userListStr = ""
      this.params = {
        noticeType: '',
        title: '',
        sender: '',
        receiver: '',
        enable: false,
        uidList: '',
        content: '',
        remark: '',
        startAt: '',
        endAt: '',
        timeUnit: '',
        timeCount: '',
        planCount: '',
        specifyTimeList: '',
      }
      this.$refs.form.resetFields()
    }
  }

}
</script>

<style lang="scss" >
.add-switch-box {
  .el-input {
    width: 200px !important;
  }
  .from-items {
    display: flex;
    .times {
      width: 440px !important;
      flex: none !important;
      margin-right: 20px;
    }
    .items {
      flex: 1;
    }
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
